import React from 'react';
import crypto from 'crypto';

const url = (email, defaultImage, size) => 'https://gravatar.com/avatar/' + crypto.createHash('md5').update(email).digest('hex') + '?d=' + encodeURIComponent(defaultImage) + '&s=' + size;

const Gravatar = ({email, defaultImage = 'mp', size = 80}) => {
  if (email) {
    return <img src={url(email, defaultImage, size)} alt={email}/>
  } else {
    return <img src={'https://assets.sakari.io/icons/person.svg'} width={size} height={size} alt="unknown"/>
  }
}

export default Gravatar;



// WEBPACK FOOTER //
// ./src/components/Common/Gravatar/index.js